const i = {
  name: "LightningFilled",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.9998 9V1H11.4298L3.25977 15H10.9998V23H12.5698L20.7398 9H12.9998Z" fill="currentColor"/>
</svg>
  `
};
export {
  i as LightningFilled
};
